import { GET_REPORT_CHAIN, CLEAR_REPORT_CHAIN } from './actions';
import { ReportChainNode, WorkflowStepOption } from '../types';

interface IReportChainState {
  originalCrashKey: string;
  nodes: ReportChainNode[];
  availableSteps: WorkflowStepOption[];
}

const initialReportChainState: IReportChainState = {
  originalCrashKey: '',
  nodes: [],
  availableSteps: [],
};

export default (
  state: IReportChainState = initialReportChainState,
  action: any
) => {
  const _state = { ...state };
  switch (action.type) {
    case GET_REPORT_CHAIN:
      _state.originalCrashKey = action.value.originalCrashKey;
      _state.nodes = [...(action.value.nodes || [])];
      _state.availableSteps = [...(action.value.availableSteps || [])];
      return _state;
    case CLEAR_REPORT_CHAIN:
      return { ...initialReportChainState };
    default:
      return _state;
  }
};
